import { Component, OnInit, ViewChild } from '@angular/core';
import { jqxScrollViewComponent } from 'jqwidgets-ng/jqxscrollview';

@Component({
  selector: 'app-airport-scrollview-for-mobile',
  templateUrl: './airport-scrollview-for-mobile.component.html',
  styleUrls: ['./airport-scrollview-for-mobile.component.css']
})
export class AirportScrollviewForMobileComponent implements OnInit {
  @ViewChild('myScrollView') myScrollView:jqxScrollViewComponent;
  constructor() { }

  ngOnInit() {
  }

}
